import GeneralErrorPage from './general-error-page'

export default GeneralErrorPage
